import { c as _c } from "react/compiler-runtime";
import { ContactPaymentOrderItemInterface } from 'modules/contacts/contact-page/types/contact-payments-interface';
import { getContactPaymentUrl } from 'modules/contacts/contact-page/utils/get-contact-payment-url';
import React from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { PricePlanTooltip } from 'shared/components/tooltip/price-plan-tooltip';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getProductPriceAmount } from 'modules/payment/transactions/utils/product-transactions-utils';
import useUser from 'shared/hooks/use-user';
interface ContactPaymentsPaymentTooltipProps {
  orderItem: ContactPaymentOrderItemInterface;
}
const ContactPaymentTooltip = t0 => {
  const $ = _c(18);
  const {
    orderItem
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const pricePlan = orderItem.pricePlan;
  const productOrderItem = orderItem.productOrderItem;
  const quantity = productOrderItem?.quantity ?? 1;
  const t1 = user?.dashboardLocale;
  let t2;
  if ($[0] !== productOrderItem || $[1] !== quantity || $[2] !== t1) {
    t2 = getProductPriceAmount(quantity, productOrderItem, t1);
    $[0] = productOrderItem;
    $[1] = quantity;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== productOrderItem || $[5] !== t) {
    t3 = productOrderItem?.productVariant && <p className="text-start"><span className="text-darkblue font-bold">{t("dashboard.price_plan.products_variant.title")}:{" "}</span>{productOrderItem.productVariant.productOptionValues?.map(_temp).join(" / ")}</p>;
    $[4] = productOrderItem;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== orderItem.offer || $[8] !== pricePlan || $[9] !== productOrderItem) {
    t4 = orderItem.offer && orderItem.offer.removedAt === null && orderItem.offer.funnelStep ? <LinkWithoutPrefetch rel="noreferrer" className="primary-link" href={getContactPaymentUrl(orderItem.offer.funnelStep.funnel.id, orderItem.offer.funnelStep.id)}>{pricePlan ? pricePlan.innerName : productOrderItem && productOrderItem.product.name}</LinkWithoutPrefetch> : pricePlan ? pricePlan.innerName : productOrderItem && productOrderItem.product.name;
    $[7] = orderItem.offer;
    $[8] = pricePlan;
    $[9] = productOrderItem;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <div className="truncate">{t4}</div>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== pricePlan || $[14] !== t2 || $[15] !== t3 || $[16] !== t5) {
    t6 = <PricePlanTooltip pricePlan={pricePlan} productPriceAmount={t2} customRow={t3}>{t5}</PricePlanTooltip>;
    $[13] = pricePlan;
    $[14] = t2;
    $[15] = t3;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};
export default ContactPaymentTooltip;
function _temp(e) {
  return e.value;
}